// Group a quiz score (0-100) into a performance band for consistent
// colour-coding across the app — the quiz-history rows and the Overall
// Performance ring. Colour the RING graphic by band; keep the % number in the
// theme text colour so it stays legible in both themes and carries the value
// (the colour is a redundant, colourblind-safe cue).
//
// The band ring colours (used in the SCSS of both consumers) are chosen to
// clear WCAG-AA graphic contrast (>=3:1) on BOTH the light and dark (#262626)
// themes: needs-work #d0453a, developing #c17d10, strong #2e9e5a.
export const scoreBand = (value) => {
  // Guard null/undefined/"" explicitly — Number() coerces those to 0, which
  // would paint a missing score red rather than leaving it neutral.
  if (value === null || value === undefined || value === "") return "none";
  const pct = Number(value);
  if (!Number.isFinite(pct)) return "none";
  if (pct >= 75) return "strong";
  if (pct >= 50) return "developing";
  return "needs-work";
};
